import Templates from "../../templates";
import { DashboardPage } from "../../organisms";
import Services from "./service";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Logo } from "../../../assets/images";
import Navbar from "../../templates/navbar";
import FooterLanding from "../../templates/footerLanding";

const Dashboard = () => {
  const { dataHeader, dataNews, addFeedback, dataBusiness } = Services();
  const { pathname } = useLocation();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(false);
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname]);
  console.log("data business", dataBusiness);

  return (
    <>
      <Navbar
        logo={Logo}
        basic={{
          classes: `border-gray-200 px-4 transition-all delay-75
      xl:pb-2.5 pt-2.5 bg-gray2/50
      fixed top-0 container text-white text-start z-50`,
        }}
        onScroll={{
          classes: `border-gray-200 transition-all delay-75 px-4 
    md:pb-2.5 md:bg-blueWebsite pt-2.5 bg-gray2
    fixed top-0 w-full text-blueWebsite z-50`,
        }}
      />
      <DashboardPage
        dataNews={dataNews}
        dataHeader={dataHeader}
        dataBusiness={dataBusiness}
        sendFeedback={(e) => addFeedback(e)}
      />
      <FooterLanding />
    </>
  );
};

export default Dashboard;
